import React from 'react';
import BaseComponent from '../../../baseClasses/BaseComponent';
import closeIcon from '../../../assets/images/close-icon.svg';
import emailIcon from '../../../assets/images/email-blue-button.svg';
import './UserAvatarWithInfoPopout.scss';

export class UserAvatarWithInfoPopout extends BaseComponent {

  componentDidMount() {
    this.handleClickOutside = event => {
      if (this.componentRef && !this.componentRef.contains(event.target)) this.handleCloseInfo(event);
    };
    document.addEventListener('click', this.handleClickOutside, false);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside, false);
  }

  handleCloseInfo(e) {
    const { handleCloseInfo } = this.props;
    e.stopPropagation();
    if (handleCloseInfo) {
      handleCloseInfo();
    }
  }

  render() {
    const {
      popupTopPosition,
      popupLeftPosition,
      userImage,
      user,
      companyName,
      title,
      flipped,
    } = this.props;

    let boxStyle;

    if (popupLeftPosition != null && popupTopPosition != null) {
      boxStyle = {
        position: 'fixed',
        top: popupTopPosition,
        left: popupLeftPosition,
      };
    }

    return (
      <div className='UserAvatarWithInfoPopout' ref={el => this.componentRef = el}>
        <div
          className="avatar-info__background"
          onClick={this.handleCloseInfo}
        />
        <div
          className={'avatar-info__box' + (flipped ? ' avatar-info__box--flipped' : '')}
          onBlur={this.handleCloseInfo}
          style={boxStyle}
        >
          <button
            className="avatar-info__close-button"
            onClick={this.handleCloseInfo}
          >
            <img
              src={closeIcon}
              className="avatar-info__close-button--icon"
              alt="close info box"
            />
          </button>
          {userImage}
          <div className="avatar-info__name">
            {user.first_name} {user.last_name}
          </div>
          {companyName &&
            <div className="avatar-info__company-name">{companyName}</div>
          }
          <div className="avatar-info__title">{title ? title : user.title}</div>
          <div className='avatar-info__email'>
            <a href={`mailto:${user.email}`} target="_top" onClick={(e) => { e.stopPropagation(); }}>
              <img src={emailIcon} alt='email' />
            </a>
            <div className='text'>Email</div>
          </div>
        </div>

      </div>
    );
  }
}

export default UserAvatarWithInfoPopout;



// WEBPACK FOOTER //
// ./src/components/UserAvatar/UserAvatarWithInfoPopout/index.js